import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class Guide extends Vue {
  @Prop({ default: () => {} })
    value: DisplayGuideData;

  @Prop()
    disabled: boolean;

  data: DisplayGuideData = {};

  @Watch('value', { deep: true, immediate: true })
  watchValue(n, o) {
    if (JSON.stringify(n) !== JSON.stringify(o)) {
      this.data = n;
    }
  }

  @Watch('data', { deep: true })
  watchData() {
    this.$emit('input', this.data);
  }

  render(h) {
    return (
      <div class="r-my-10 r-mx-20">
        <el-form props={{ model: this.data.desc }} show-message={false} ref="form">
          <el-form-item prop={'guideContent'} rules={{ required: true, trigger: ['blur', 'change'] }}>
            <el-input type="textarea" autosize={{ minRows: 4, maxRows: 8 }} placeholder="请输入文本" show-word-limit maxlength={100} disabled={this.disabled} v-model={this.data.desc.guideContent}></el-input>
          </el-form-item>
        </el-form>
      </div>
    );
  }
}
